import { ActivityGridWebComponent } from './component/ActivityGridWebComponent';
import { WEB_COMPONENT_WIDGET_ENDPOINT_INVESTIGATION_ACTIVITY_GRID } from '../../webcomponents.constants';

export { ActivityGridWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_ENDPOINT_INVESTIGATION_ACTIVITY_GRID, ActivityGridWebComponent);
